<div class="bg-primary">
  <div class="container-fluid py-2">
    <div class="row">
      <ul class="nav">
        <li class="nav-item">
          <a
            class="nav-link"
            routerLinkActive="active"
            data-test-id="communities-filter"
            [routerLink]="['/map', mapFilters.COMMUNITIES.toLowerCase()]"
          >
            {{ 'MAP_COMMUNITIES_HINT' | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            routerLinkActive="active"
            data-test-id="projects-filter"
            [routerLink]="['/map', mapFilters.PROJECTS.toLowerCase()]"
          >
            {{ 'MAP_PROJECTS_HINT' | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            routerLinkActive="active"
            data-test-id="organizations-filter"
            [routerLink]="['/map', mapFilters.ORGANIZATIONS.toLowerCase()]"
          >
            {{ 'MAP_ORGANIZATIONS_HINT' | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            routerLinkActive="active"
            data-test-id="people-filter"
            [routerLink]="['/map', mapFilters.PEOPLE.toLowerCase()]"
          >
            {{ 'MAP_PEOPLE_HINT' | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            routerLinkActive="active"
            data-test-id="covid-filter"
            [routerLink]="['/map', mapFilters.COVID.toLowerCase()]"
          >
            {{ 'MAP_COVID_HINT' | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
